import { render, staticRenderFns } from "./TabDispositivos.vue?vue&type=template&id=5b97e824&"
import script from "./TabDispositivos.vue?vue&type=script&lang=ts&"
export * from "./TabDispositivos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5b97e824', component.options)
    } else {
      api.reload('5b97e824', component.options)
    }
    module.hot.accept("./TabDispositivos.vue?vue&type=template&id=5b97e824&", function () {
      api.rerender('5b97e824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/BajasCobranza/gridActions/tabs/TabDispositivos.vue"
export default component.exports